import { CheckIcon } from '@heroicons/react/20/solid';
import { BUSINESS_TEASER } from './produktContent';

// Cross-Sell-Band für sVisit Business (extern auf www.svisit.ch).
const BusinessTeaser = () => (
  <section
    aria-labelledby="business-heading"
    className="overflow-hidden rounded-2xl bg-gray-900"
  >
    <div className="grid items-center lg:grid-cols-2">
      <div className="px-6 py-12 sm:px-10 lg:py-16">
        <p className="text-sm font-semibold uppercase tracking-wide text-svisit-primary-300">
          Für Teams
        </p>
        <h2
          id="business-heading"
          className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl"
        >
          {BUSINESS_TEASER.title}
        </h2>
        <p className="mt-4 text-lg text-gray-300">{BUSINESS_TEASER.tagline}</p>
        <ul role="list" className="mt-6 space-y-2">
          {BUSINESS_TEASER.bullets.map((bullet) => (
            <li key={bullet} className="flex items-start text-gray-200">
              <CheckIcon
                className="mr-2 mt-0.5 h-5 w-5 shrink-0 text-svisit-primary-300"
                aria-hidden="true"
              />
              {bullet}
            </li>
          ))}
        </ul>
        <p className="mt-6 text-base font-semibold text-white">
          {BUSINESS_TEASER.price}
        </p>
        <p className="mt-1 text-sm text-gray-400">{BUSINESS_TEASER.note}</p>
        <div className="mt-8 flex flex-wrap gap-4">
          <a
            href={BUSINESS_TEASER.href}
            className="rounded-md bg-svisit-primary-600 px-5 py-3 text-base font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600"
          >
            Mehr erfahren
          </a>
          <a
            href={BUSINESS_TEASER.demoHref}
            className="rounded-md px-5 py-3 text-base font-semibold text-white ring-1 ring-inset ring-white/30 hover:bg-white/10"
          >
            Demo buchen
          </a>
        </div>
      </div>
      <div className="relative h-64 sm:h-80 lg:h-full lg:min-h-[28rem]">
        <img
          src={BUSINESS_TEASER.image}
          alt={BUSINESS_TEASER.imageAlt}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-left-top"
        />
      </div>
    </div>
  </section>
);

export default BusinessTeaser;
